import styled from '@emotion/styled';
import React from 'react';
import { flexCenter } from './../_shared/styled-mixins';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';

export const StyledButtonLink = styled(Link)`
  ${flexCenter};
  text-decoration: none;
  color: var(--primary-color) !important;
  background-color: var(--secondary-color);
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  font-weight: 800;
  color: #fff !important;
  white-space: nowrap;
  padding: 0.6rem 1.2rem;
  border-radius: var(--radius);
  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease 0s;
  cursor: pointer;
  outline: none;

  &:hover {
    color: var(--darkbg-content-color) !important;
    background-color: var(--bright-purple-color);
  }
`;

const ButtonLink = ({ label, link }) => {
  return (
    <React.Fragment>
      {label && link && (
        <StyledButtonLink to={link ? link : '#'} rel="noopener">
          {label}
        </StyledButtonLink>
      )}
    </React.Fragment>
  );
};

ButtonLink.propTypes = {
  label: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
};

export default ButtonLink;
